var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "klaviyo-form",
      class: _vm.embedClass,
      attrs: {
        id: "email_signup",
        "data-ajax-submit":
          "//manage.kmail-lists.com/ajax/subscriptions/subscribe",
        action: "//manage.kmail-lists.com/subscriptions/subscribe",
        method: "GET",
        target: "_blank",
        "accept-charset": "UTF-8",
        _lpchecked: "1"
      },
      on: { submit: _vm.showMessaging }
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "form_type", value: "customer" }
      }),
      _c("input", {
        attrs: { type: "hidden", name: "g" },
        domProps: { value: _vm.listId }
      }),
      _c(
        "transition",
        { attrs: { name: "slideOut" } },
        [
          _vm.notSubmitted
            ? _c("text-input", {
                staticClass: "klaviyo-form__input",
                attrs: {
                  type: "email",
                  name: "email",
                  id: "k_id_email",
                  value: "",
                  label: "Email Address",
                  "error-text": "You must enter a valid email",
                  placeholder: _vm.placeholder,
                  autocorrect: "off",
                  autocapitalize: "off",
                  autocomplete: "email",
                  required: "",
                  "aria-label": "Email",
                  icon: "arrow-right",
                  "icon-is-submit-button": "",
                  width: "20px",
                  height: "20px",
                  "hide-label": "",
                  "email-capture": ""
                },
                model: {
                  value: _vm.emailInput,
                  callback: function($$v) {
                    _vm.emailInput = $$v
                  },
                  expression: "emailInput"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c("transition", { attrs: { name: "slideIn" } }, [
        _vm.isSuccess && _vm.message
          ? _c("p", { staticClass: "contact-form__success" }, [
              _vm._v(_vm._s(_vm.message))
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }